import { SET_AVAILABLE_LANGUAGES, SET_SELECTED_LANGUAGE } from "../action-types/app-types";

const initialState = {
    availableLanguages: [],
    selectedLanguage: 'eng'
}

export default function(state = initialState, action){
    switch(action.type) {
        case SET_AVAILABLE_LANGUAGES:

            return {
                ...state,
                availableLanguages: action.payload
            };
        case SET_SELECTED_LANGUAGE:
          return {
            ...state,
          }
        default:
            return state;
    }
}
